import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

    /**
     * Job Search DATA STORE
     */
    jobSearch: [
      // Map out your job search
      {
        name: 'Map out your job search',
        description: 'A little bit about the document',
        category: 'text',
        route: '01'
      },

      // Find out who’s hiring
      {
        name: 'Find out who’s hiring',
        description: 'A little bit about the document',
        category: 'text',
        route: '02'
      },

      // Craft your resume
      {
        name: 'Craft your resume',
        description: 'A little bit about the document',
        category: 'text',
        route: '03'
      },

      // Check your resume
      {
        name: 'Check your resume',
        description: 'A little bit about the document',
        category: 'text',
        route: '04'
      },

      // Design a winning cover letter
      {
        name: 'Design a winning cover letter',
        description: 'A little bit about the document',
        category: 'text',
        route: '05'
      },

      // Make your resume and cover letter shine
      {
        name: 'Make your resume and cover letter shine',
        description: 'A little bit about the document',
        category: 'text',
        route: '06'
      },

      // Apply for the job
      {
        name: 'Apply for the job',
        description: 'A little bit about the document',
        category: 'text',
        route: '07'
      },

      // Learn from other students’ experiences
      {
        name: 'Learn from other students’ experiences',
        description: 'A little bit about the document',
        category: 'text',
        route: '08'
      }
    ],

    interviewPrep: [
      // Boost your confidence before the interview
      {
        name: 'Boost your confidence before the interview',
        description: 'A little bit about the document',
        category: 'text',
        route: '01'
      },

      // Navigate the interview with ease
      {
        name: 'Navigate the interview with ease',
        description: 'A little bit about the document',
        category: 'text',
        route: '02'
      },

      // Interview prep for people with disabilities
      {
        name: 'Interview prep for people with disabilities',
        description: 'A little bit about the document',
        category: 'text',
        route: '03'
      },

      // Reflect on the interview to learn and grow
      {
        name: 'Reflect on the interview to learn and grow',
        description: 'A little bit about the document',
        category: 'text',
        route: '04'
      },

      // Learn from other students’ experiences
      {
        name: 'Learn from other students’ experiences',
        description: 'A little bit about the document',
        category: 'text',
        route: '05'
      }
    ],

    onTheJobSuccess: [
      // Assess your employability skills
      {
        name: 'Assess your employability skills',
        description: 'A little bit about the document',
        category: 'text',
        route: '01'
      },

      // Establish SMART learning goals
      {
        name: 'Establish SMART learning goals',
        description: 'A little bit about the document',
        category: 'text',
        route: '02'
      },

      // Anticipate and meet employer expectations
      {
        name: 'Anticipate and meet employer expectations',
        description: 'A little bit about the document',
        category: 'text',
        route: '03'
      },

      // Make the most of your work experience
      {
        name: 'Make the most of your work experience',
        description: 'A little bit about the document',
        category: 'text',
        route: '04'
      },

      // Learn from other students’ experiences
      {
        name: 'Learn from other students’ experiences',
        description: 'A little bit about the document',
        category: 'text',
        route: '05'
      }
    ],

    futureCareerPlanning: [
      // Reflect on your on-campus work experience
      {
        name: 'Reflect on your on-campus work experience',
        description: 'A little bit about the document',
        category: 'text',
        route: '01'
      },

      // Articulate your new skills to employers
      {
        name: 'Articulate your new skills to employers ',
        description: 'A little bit about the document',
        category: 'text',
        route: '02'
      },

      // Update your resume to reflect your experience and new skills
      {
        name: 'Update your resume',
        description: 'A little bit about the document',
        category: 'text',
        route: '03'
      },

      // Update your LinkedIn profile
      {
        name: 'Update your LinkedIn profile ',
        description: 'A little bit about the document',
        category: 'text',
        route: '04'
      },

      // Consider your next steps
      {
        name: 'Consider your next steps',
        description: 'A little bit about the document',
        category: 'text',
        route: '05'
      },

      // Additional resources
      {
        name: 'Additional resources',
        description: 'A little bit about the document',
        category: 'text',
        route: '06'
      },

      // Learn from other students’ experiences
      {
        name: 'Learn from other students’ experiences',
        description: 'A little bit about the document',
        category: 'text',
        route: '07'
      }
    ]
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
